// Date.now() at the server render, reused by the browser while hydrating so time-based output
// (the event countdowns) matches the server HTML. Components switch to the live clock on mount.
export const useRenderTime = () => useState('render-time', () => Date.now()).value
